// extracted by mini-css-extract-plugin
export default {"chatbot":"styles_chatbot__qouIU"};